import { Icon as e } from "../icon/index.js";
import t from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Toaster as i, toast as a } from "sonner";
// src/design/toast/index.tsx
var o = {
	success: /* @__PURE__ */ n(e, {
		name: "CheckCircle",
		className: "w-5 h-5"
	}),
	error: /* @__PURE__ */ n(e, {
		name: "AlertCircle",
		className: "w-5 h-5"
	}),
	warning: /* @__PURE__ */ n(e, {
		name: "AlertTriangle",
		className: "w-5 h-5"
	}),
	info: /* @__PURE__ */ n(e, {
		name: "Info",
		className: "w-5 h-5"
	}),
	loading: /* @__PURE__ */ n(e, {
		name: "Loader2",
		className: "w-5 h-5 animate-spin"
	}),
	default: /* @__PURE__ */ n("span", {})
}, s = (e, t) => ({
	headline: e ?? t ?? "",
	description: e === void 0 ? void 0 : t
});
function c(t = {}) {
	let { placement: r = "bottom-end", max: i = 3, gap: c = 8, duration: l = 5e3 } = t, u = (t) => {
		let { title: r, description: i, type: c = "default", icon: u, action: d, duration: f, dismissible: p = !0 } = t, { headline: m, description: h } = s(r, i);
		return a(m, {
			duration: f ?? l,
			icon: u || o[c],
			description: h,
			action: d ? {
				label: d.label,
				onClick: d.onClick
			} : void 0,
			cancel: p ? {
				label: /* @__PURE__ */ n(e, {
					name: "X",
					className: "w-4 h-4"
				}),
				onClick: () => {}
			} : void 0
		});
	}, d = (e, t) => (n, r) => e(n, {
		duration: r?.duration ?? l,
		icon: r?.icon || o[t],
		description: r?.description,
		action: r?.action
	});
	return {
		toast: u,
		update: (e, t) => {
			let { headline: n, description: r } = s(t.title, t.description);
			a(n, {
				id: e,
				description: r,
				duration: t.duration
			});
		},
		dismiss: (e) => {
			a.dismiss(e);
		},
		dismissAll: () => {
			a.dismiss();
		},
		success: d(a.success, "success"),
		error: d(a.error, "error"),
		warning: d(a.warning, "warning"),
		info: d(a.info, "info"),
		loading: (e, t) => a.loading(e, {
			duration: 0,
			icon: t?.icon || o.loading,
			description: t?.description
		}),
		_sonner: a,
		_placement: r,
		_max: i,
		_gap: c
	};
}
function l({ manager: e, className: t }) {
	return /* @__PURE__ */ n(i, {
		position: ((e) => {
			switch (e) {
				case "top-start": return "top-left";
				case "top": return "top-center";
				case "top-end": return "top-right";
				case "bottom-start": return "bottom-left";
				case "bottom": return "bottom-center";
				default: return "bottom-right";
			}
		})(e._placement),
		visibleToasts: e._max,
		richColors: !0,
		closeButton: !0,
		toastOptions: {
			duration: 5e3,
			className: "font-sans",
			classNames: { closeButton: "!absolute !left-[unset] !-right-1 !top-3 !border-0 !bg-transparent hover:!bg-muted !rounded-md !transition-colors !shadow-none" }
		},
		className: t,
		style: { zIndex: "var(--z-index-toast)" },
		gap: e._gap
	});
}
var u = t.createContext(null);
function d({ children: e, config: i }) {
	let a = t.useMemo(() => c(i), [i]);
	return /* @__PURE__ */ r(u.Provider, {
		value: a,
		children: [e, /* @__PURE__ */ n(l, { manager: a })]
	});
}
function f() {
	let e = t.useContext(u);
	if (!e) throw Error("useToast must be used within a ToastProvider");
	return e;
}
function p(e) {
	return t.useMemo(() => c(e), [e]);
}
var m = { async loading(e, t, n) {
	let r = n.loading(t.loading);
	try {
		let i = await e;
		n.dismiss(r);
		let a = typeof t.success == "function" ? t.success(i) : t.success;
		return n.success(a), i;
	} catch (e) {
		n.dismiss(r);
		let i = typeof t.error == "function" ? t.error(e) : t.error;
		throw n.error(i), e;
	}
} };
export { d as ToastProvider, l as Toaster, c as createToastManager, m as promiseToast, a as sonnerToast, f as useToast, p as useToastManager };

//# sourceMappingURL=index.js.map